import axios from 'axios'

export default {
  getYear() {
    return axios.get('/api/recom/year')
  },
  setYear(newYear) {
    return axios.put('/api/recom/year', { year: newYear })
  },
  getExamSubjects() {
    return axios.get('/api/recom/ege-subjects')
  },
  addExamSubject(name) {
    return axios.post('/api/recom/ege-subjects', { name })
  },
  updateExamSubject(data) {
    return axios.put('/api/recom/ege-subjects', data)
  },
  deleteExamSubject(id) {
    return axios.delete(`/api/recom/ege-subjects/${id}`)
  },
  getDirectionGroups() {
    return axios.get('/api/recom/direction-groups')
  },
  addDirectionGroup(data) {
    return axios.post('/api/recom/direction-groups', data)
  },
  updateDirectionGroup(data) {
    return axios.put('/api/recom/direction-groups', data)
  },
  deleteDirectionGroup(id) {
    return axios.delete(`/api/recom/direction-groups/${id}`)
  },
  getAllDirections() {
    return axios.get('/api/recom/all-directions')
  },
  getDirectionsByGroup(id) {
    const params = new URLSearchParams()
    if (id) {
      params.append('groupId', id)
    }
    return axios.get(`/api/recom/education-directions?${params.toString()}`)
  },
  addDirection(data) {
    return axios.post('/api/recom/education-directions', data)
  },
  updateDirection(data) {
    return axios.put('/api/recom/education-directions', data)
  },
  deleteDirection(id) {
    return axios.delete(`/api/recom/education-directions/${id}`)
  },
  getUniversities() {
    return axios.get('/api/recom/universities')
  },
  getOlympiads() {
    return axios.get('/api/recom/olympiads')
  },
  getUniversityDirections(id) {
    return axios.get(`/api/recom/directions-university/${id}`)
  },
  updateUniversityDirections(id, data) {
    return axios.put(`/api/recom/directions-university/${id}`, data)
  },
  deleteUniversityDirections(universityId, directionId) {
    return axios.delete(`/api/recom/directions-university/${universityId}/${directionId}`)
  },
  getDirectionsByUniversity(organizationId) {
    const params = new URLSearchParams()
    if (organizationId) {
      params.append('organizationId', organizationId)
    }
    return axios.get(`/api/recom/stuff?${params.toString()}`)
  },
  getDirectionsById(id) {
    const params = new URLSearchParams()
    if(id)
      params.append('directionId', id);
    return axios.get(`/api/recom/stuff?${params.toString()}`);
  },
  getProfessionsList() {
    return axios.get(`/api/recom/profession/list`);
  },
  addProfession(data) {
    return axios.post(`/api/recom/profession/add`, data);
  },
  editProfession(data) {
    return axios.put(`/api/recom/profession/edit/${data.id}`, data);
  },
  deleteProfession(id) {
    return axios.delete(`/api/recom/profession/delete/${id}`)
  },
  getProfession(id) {
    return axios.get(`/api/recom/profession/${id}`)
  },
  markProfession(id) {
    return axios.post(`/api/recom/profession/mark/${id}`);
  },
  unmarkProfession(id) {
    return axios.delete(`/api/recom/profession/mark/${id}`);
  },
  getMarkedProfessionsByUser() {
    return axios.get(`/api/recom/profession/marked`);
  },
  isProfessionMarked(id) {
    return axios.get(`/api/recom/profession/ismarked/${id}`);
  }
}
